import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import RewardService from "./RewardService";
import Swal from "sweetalert2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Card, TextField, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RewardService from "services/rewardService";
import { toast } from "react-toastify";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { claimOtp } from "services/rewardService";

const OTP = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [inputRefs, setInputRefs] = useState(
    Array(4)
      .fill(null)
      .map(() => React.createRef())
  );

  const handleInputChange = (event, index) => {
    const { value } = event.target;
    if (value.length === 1 && index < 3) {
      inputRefs[index].current.value = value;
      inputRefs[index + 1].current.focus();
    }
    let currentOtp = "";
    inputRefs.forEach((ref) => {
      currentOtp += ref.current.value;
    });
    setOtp(currentOtp);
  };

  const handleKeyDown = (event, index) => {
    if (event.keyCode === 8 && index !== 0) {
      event.preventDefault();
      inputRefs[index].current.value = "";
      inputRefs[index - 1].current.focus();
    }
    let currentOtp = "";
    inputRefs.forEach((ref) => {
      currentOtp += ref.current.value;
    });
    setOtp(currentOtp);
  };

  const otpHandler = async () => {
    if (otp.length === 4) {
      const otpData = {
        otp: otp,
        amount: location.state.amount,
      };
      const res = await claimOtp(otpData);

      if (res.data.msg === "OTP matched reward request placed successfully") {
        toast.success(`${res}`, {
          style: {
            fontSize: "15px",
          },
        });

        navigate("/verified");
      } else {
        toast.error(`${res}`, {
          style: {
            fontSize: "15px",
          },
        });
      }
    } else {
      Swal.fire("Invalid OTP", "Enter the complete otp", "warning");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card
        sx={{
          marginTop: "1rem",
          padding: 2,
          justifyContent: "center",
          alignItems: "center",
          rowGap: 2,
        }}
      >
        <MDBox sx={{ marginBottom: "1rem" }}>
          <MDTypography fontWeight="bold" fontSize="25px">
            Enter OTP
          </MDTypography>
        </MDBox>

        <MDBox sx={{ marginBottom: "1rem" }}>
          <MDTypography>
            Sent to{" "}
            <span style={{ color: "#F5D243" }}>{location.state.email}</span>
          </MDTypography>
        </MDBox>

        <MDBox sx={{ marginBottom: "1rem" }}>
          {inputRefs.map((ref, index) => (
            <TextField
              sx={{ width: "50px", marginLeft: "1rem" }}
              variant="outlined"
              key={index}
              inputRef={ref}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{ maxLength: 1 }}
            />
          ))}
        </MDBox>

        <MDButton color="singh" onClick={otpHandler}>
          Verify
        </MDButton>
      </Card>
    </DashboardLayout>
  );
};

export default OTP;
